/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePropertyRequest
 */
export interface UpdatePropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePropertyRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the UpdatePropertyRequest interface.
 */
export function instanceOfUpdatePropertyRequest(value: object): value is UpdatePropertyRequest {
    return true;
}

export function UpdatePropertyRequestFromJSON(json: any): UpdatePropertyRequest {
    return UpdatePropertyRequestFromJSONTyped(json, false);
}

export function UpdatePropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdatePropertyRequestToJSON(json: any): UpdatePropertyRequest {
    return UpdatePropertyRequestToJSONTyped(json, false);
}

export function UpdatePropertyRequestToJSONTyped(value?: UpdatePropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streetAddress': value['streetAddress'],
        'unit': value['unit'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'notes': value['notes'],
    };
}

